import { createIcon } from '../createIcon.tsx';

export const InboxIcon = createIcon(
	'InboxIcon',
	<>
		<path d="M4 4h16v8a2 2 0 0 1-2 2h-3l-2 3-2-3H6a2 2 0 0 1-2-2V4Z" />
		<path d="m22 4-10 7L2 4" />
	</>,
);
